<template>
  <div id="overlay">
    <div class="center w-11/12  ">
      <div
        class="content border border-1 border-solid bg-white p-2 flex flex-col"
      >
        <div class="text-gray-800 text-2xl my-auto">
          {{ "Further Information" }}
        </div>
        <div class="text-gray-800 text-sm overflow-auto">
            {{text}}
         
        </div>
        <div class="w-full justify-end p-3 flex cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http, { OCR_ENDPOINTS } from "../request";
import "vue-toastification/dist/index.css";
export default {
  props: {
    text: String,
  },

  data() {
    return {
    };
  },
  created() {
    this.getProjects();
  },
  methods: {
    getProjects() {
      Http()
        .get(OCR_ENDPOINTS.projects, {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: false,
        })
        .then((response) => {
          this.projects = response.data;
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}
</style>
